import { ThankYou, ThankYouCommonInterface } from '@systemeio/digital-store-shared'
import { FormInput } from '@systemeio/ui'
import ItemSteps from 'modules/stores/store/components/item-steps'
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context'
import { ThankYouPageErrorsType } from 'modules/stores/store/types/store-common-interface'
import { FC, useEffect } from 'react'
import FormTextarea from 'shared/components/form-textarea'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ThankYouTabProps {
  thankYouPage: ThankYouCommonInterface['thankYouPage']
  onChange: (thankYouPage: ThankYouCommonInterface['thankYouPage']) => void
  errors: ThankYouPageErrorsType
}

const ThankYouTab: FC<ThankYouTabProps> = ({ thankYouPage, onChange, errors }) => {
  const { t } = useLocoTranslation()

  const { setPreview, setSingleItemMode } = useStorePreviewContext()

  useEffect(() => {
    setPreview([
      <ThankYou
        key={'Thank you page preview'}
        thankYouPage={thankYouPage}
        displayAffiliateLink={false}
      />,
    ])
    setSingleItemMode(true)
  }, [setPreview, setSingleItemMode, thankYouPage])

  return (
    <ItemSteps
      steps={[
        {
          key: 'text',
          title: t('dashboard.store.item.add_text'),
          element: (
            <div className={'flex flex-col gap-5'}>
              <FormInput
                required
                value={thankYouPage.title}
                label={t('dashboard.store.item.title')}
                onChange={({ target: { value } }) => onChange({ ...thankYouPage, title: value })}
                error={errors['thankYouPage.title']}
              />
              <FormTextarea
                required
                value={thankYouPage.text}
                label={t('dashboard.store.item.subtitle')}
                onChange={({ target: { value } }) => onChange({ ...thankYouPage, text: value })}
                error={errors['thankYouPage.text']}
              />
            </div>
          ),
        },
      ]}
    />
  )
}

export default ThankYouTab
